import { atom } from 'recoil';
import { getDefaultReportingDateRange } from '../constants/reportingConfig';
import {
  DEFAULT_TEMPLATE_BUTTONS,
  DEFAULT_TEMPLATE_FILTERS,
  DEFAULT_TEMPLATE_FORM,
} from '../utils/templateConstants';

const { startDate, endDate } = getDefaultReportingDateRange();

export const templateFiltersAtom = atom({
  key: 'whatsappTemplateFiltersAtom_v2',
  default: { ...DEFAULT_TEMPLATE_FILTERS },
});

export const templateFormAtom = atom({
  key: 'whatsappTemplateFormAtom_v2',
  default: { ...DEFAULT_TEMPLATE_FORM },
});

export const templateFormButtonsAtom = atom({
  key: 'whatsappTemplateFormButtonsAtom_v2',
  default: { ...DEFAULT_TEMPLATE_BUTTONS },
});

export const templateFormErrorsAtom = atom({
  key: 'whatsappTemplateFormErrorsAtom_v2',
  default: {},
});

export const templateSendDialogAtom = atom({
  key: 'whatsappTemplateSendDialogAtom_v2',
  default: { open: false, template: null },
});

export const templateSummaryFiltersAtom = atom({
  key: 'whatsappTemplateSummaryFiltersAtom_v2',
  default: {
    template_id: '',
    page: 0,
    limit: 10,
    start_date: startDate,
    end_date: endDate,
    sort_by: 'sent_date',
    order: 'desc',
  },
});

export const wabaSelectedAppAtom = atom({
  key: 'whatsappWabaSelectedAppAtom_v2',
  default: null,
});

export const templateListRefreshAtom = atom({
  key: 'whatsappTemplateListRefreshAtom_v2',
  default: 0,
});

export const templateReportingScopeAtom = atom({
  key: 'whatsappTemplateReportingScopeAtom_v2',
  default: {
    organisation: '',
    organisationObj: null,
    botNumber: '',
    botNumberObj: null,
    category: '',
    categoryObj: null,
    language: '',
    languageObj: null,
    startDate: null,
    endDate: null,
  },
});
